// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"81815905550a8217","2722":"0f79dbe9ea1e3c77","3197":"338401822fed3806","3877":"fe336940f98fdfab","4450":"b65f0219ee7b43d5","5461":"3f0f216f36b6724f"}[chunkId] + ".css";
};